import React from 'react';
import { Link, Navigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
import { ADMIN_EMAIL } from '../services/adminService';
import EmailTemplatePanel from '../components/admin/EmailTemplatePanel';

/**
 * Full-screen email-template editor — the inline Email tab is too narrow to show the whole email width, so this
 * dedicated page gives the editor + live preview the full viewport (a wide preview beside a compact form).
 * Admin-only (same guard as /admin): auth is enforced by the ProtectedRoute wrapper, admin by the email check.
 */
const EmailEditorPage: React.FC = () => {
  const { user } = useAuth();
  if (user && user.email !== ADMIN_EMAIL) return <Navigate to="/dashboard" replace />;

  return (
    <div className="min-h-screen bg-white dark:bg-black">
      <div className="max-w-none px-6 py-5">
        {/* Breadcrumb back to the admin dashboard */}
        <nav className="mb-4 flex items-center gap-1.5 text-sm text-secondary-500">
          <Link to="/admin" className="inline-flex items-center gap-1.5 hover:text-secondary-800 dark:hover:text-secondary-200">
            <ArrowLeft className="w-4 h-4" /> Admin
          </Link>
          <span className="text-secondary-300">/</span>
          <span className="text-secondary-800 dark:text-secondary-200">Email editor</span>
        </nav>
        <EmailTemplatePanel fullScreen />
      </div>
    </div>
  );
};

export default EmailEditorPage;
